export const HALLOWEEN_PROMO_GIFT_SKU = ['100009937'];

export const HALLOWEEN_PROMO_GIFT_COUPON = 'sshelloweenfreegift25';
